import {Pipe, PipeTransform} from '@angular/core';
import {SiteTypeDto} from '../../gateways/dtos/site-type-dto';

@Pipe({
    name: 'siteTypeIcon'
})
export class SiteTypeIconPipe implements PipeTransform {

    transform(siteTypeId, allSiteTypes: SiteTypeDto[]): string {
        if (siteTypeId !== undefined && allSiteTypes !== undefined) {
            const findSiteType = allSiteTypes.findIndex(x => x.id === siteTypeId);
            if (findSiteType !== -1) {
                return allSiteTypes[findSiteType].icon;
            } else {
                return 'eye-off-outline';
            }
        }
    }

}
